import { useCallback, useState } from 'react';

export interface AuthLegalModalState {
  hasOpenedPolicy: boolean;
  hasOpenedTerms: boolean;
  showPolicy: boolean;
  showTerms: boolean;
  handleClosePolicy: () => void;
  handleCloseTerms: () => void;
  handleOpenTerms: () => void;
  handlePrivacyClick: () => void;
}

export function useAuthLegalModalState(): AuthLegalModalState {
  const [showTerms, setShowTerms] = useState(false);
  const [showPolicy, setShowPolicy] = useState(false);
  const [hasOpenedTerms, setHasOpenedTerms] = useState(false);
  const [hasOpenedPolicy, setHasOpenedPolicy] = useState(false);

  const handleOpenTerms = useCallback((): void => {
    setHasOpenedTerms(true);
    setShowTerms(true);
  }, []);

  const handleCloseTerms = useCallback((): void => {
    setShowTerms(false);
  }, []);

  const handlePrivacyClick = useCallback((): void => {
    setHasOpenedPolicy(true);
    setShowPolicy(true);
  }, []);

  const handleClosePolicy = useCallback((): void => {
    setShowPolicy(false);
  }, []);

  return {
    hasOpenedPolicy,
    hasOpenedTerms,
    showPolicy,
    showTerms,
    handleClosePolicy,
    handleCloseTerms,
    handleOpenTerms,
    handlePrivacyClick,
  };
}
